import React, { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie'; 
import { Link, useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email');
      return;
    }
    try {
      const response = await axios.post(`${API_BASE_URL}forgot-password/request-otp`, { email });
      console.log('API Response:', response);
      if (response.status === 200) {
        setMessage('OTP has been sent to your email.');
        Cookies.set('email', email, { expires: 1 / 24 });
        navigate('/otp', { state: { email } });
      } else {
        setError(response.data.error || 'An error occurred while sending the OTP.');
      }
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setError('User with this email does not exist.');
      } else {
        setError('An error occurred. Please try again.');
      }
    }
  };

  return (
    <div className="container">
          <div className="forget-password-page">
         
          {message && <p className='text-center' style={{ color: 'green' }}>{message}</p>}
         
            <div className="form rounded-4 white-box-shadow">
              <form className="forget-password-form" onSubmit={handleSubmit}>
                <div className="form-group">
                <h2 className='text-center gradient-text'>Find your account</h2>
                  <div className="form-field position-relative">
                  <i class="fa-regular fa-envelope"></i>
                    <input
                      className="form-control"
                      name="email"
                      placeholder="Email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                />
                 {error && <p className="error-message" style={{ color: 'red' }}>{error}</p>}
                  </div>
                </div>
                <div className="form-group form-btns mt-3">
                  <div className="form-field">
                    <button type="submit" className="ls-btn">Send OTP</button>
                  </div>
                </div>
                <div>
                <p className="message">
                <Link to="/">Go to home page</Link>
                </p>
                </div>
              </form>
            </div>
          </div>
        </div>
  );
};
export default ForgotPassword;
